import { useSettings } from '../providers/SettingsProviders'

export function useChatEnabled() {
  const { settings } = useSettings()

  return !(settings?.live.status == 'ended' || !settings?.uiSettings.showChat)
}
